export const LangOption = [
    {
        key: 'zh',
        value: '中文'
    },
    {
        key: 'en',
        value: 'English'
    },
    {
        key: 'es',
        value: 'Español'
    },
    {
        key: 'vi',
        value: 'Tiếng việt nam'
    },
    {
        key: 'id',
        value: 'Indonesian'
    }
]
